export default __webpack_public_path__ + "static/TitilliumWeb-Regular-b46574b172bda9b775b94779caabe186.woff";